export enum AgentAssistRoutes {
  MAIN = '/aa',
  LOGIN = '/aa/login',
  MENU = '/aa/menu',
  GRANT = '/aa/grant',
  VOID = '/aa/void',
  REPRINT = '/aa/reprint',
}
